import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import client from "../lib/api/client";
import {withRouter} from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import TitleHead from "../assets/title_head.svg";

// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins.pkgd.min.js';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import moment from "moment";

// import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

const useStyles = makeStyles(theme => ({
    root: {
        height: "100%",
        width: "100%",
        margin: "30px 0"
    },
    title: {
        fontSize: "17px",
        fontWeight: "bold"
    },
    label: {
        fontSize: "14px",
        fontWeight: "bold",
        marginRight: "15px",
        textAlign: "center"
    },
    crtby: {
        fontSize: "14px",
        marginRight: "20px",
        textAlign: "center"
    },
    wtireButton: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        marginTop: "10px",
        gap: "10px"
    },
    box: {
        margin: "20px 0"
    },
    headerWrapper: {
        margin: "20px 0",
        display: "flex",
        alignItems: "center"
    },
    divider: {
        margin: "30px 0",
        height: "2px",
        backgroundColor: "#333333"
    }
}));

const ViewForm = ({ setViewState, brdNo, setReTitle, history }) => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [crtDt, setCrtDt] = useState("");
    const [crtby, setcrtby] = useState("");
    const [answer, setAnswer] = useState("");
    const [answerBy, setAnswerBy] = useState("");
    const [answerDt, setAnswerDt] = useState("");
    const classes = useStyles();

    useEffect(() => {
        client.get(`/kognr/board/${brdNo}`, {cache: false}).then(response => {
          const payload = response.data.payload;
            // const data = window.atob(response.data.payload.content);
            // const decoded = decodeURIComponent(data);

          if (payload && payload.redirect) {
            // console.log("redirect 응답 감지:", payload.redirect);
            handleListClick();
            return;
          }

            const { board, answerData } = response.data.payload;
            const { content, title, crtDate, crtby } = board;

            setTitle(title);
            setContent(content);
            setCrtDt(crtDate);
            setcrtby(crtby);

            if (answerData.ansNo) {
                const { answer, crtby, crtDate } = answerData;
                // const decoded = decodeURIComponent(data);

                setAnswer(answer);
                setAnswerBy(crtby);
                setAnswerDt(crtDate);
            }

        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const handleModifyClick = () => {
        setViewState("WRITE");
        history.push(`/question/${brdNo}`);
    }

    const handleReQuestionClick = () => {
        setViewState("WRITE");
        setReTitle("[재질문] " + title);
        history.push(`/questions`);
    }

    const handleListClick = () => {
        setViewState("LIST");
        history.push("/questions");
    }

    return (
        content !== "" &&
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <div className="title-head">
                        <img src={TitleHead} alt=""/>
                        <span>1:1 문의</span>
                    </div>
                    <Divider className={classes.divider} />

                    <div className={classes.box}>
                        <span className={classes.title}>{title}</span>
                    </div>
                    <div className={classes.headerWrapper}>
                        <div className={classes.label}>작성자</div>
                        <div className={classes.crtby}>{crtby}</div>

                        <span className={classes.label}>등록일</span>
                        <span className={classes.crtby}>{moment(new Date(crtDt)).format("YYYY-MM-DD HH:mm:ss")}</span>
                    </div>

                    <Divider />

                    <div className={classes.box}>
                        <div className="fr-wrapper">
                            <div className="fr-element fr-view" dangerouslySetInnerHTML={ {__html: content} }>
                            </div>
                        </div>
                        {/*<FroalaEditorView*/}
                        {/*    model={content}*/}
                        {/*/>*/}
                    </div>

                    <Divider className={classes.divider} />

                    {answer && (
                        <div>
                            <div className={classes.headerWrapper}>
                                <span className={classes.label}>답변자</span>
                                <span className={classes.crtby}>{answerBy}</span>
                                <span className={classes.label}>답변일</span>
                                <span className={classes.crtby}>{moment(new Date(answerDt)).format("YYYY-MM-DD HH:mm:ss")}</span>
                            </div>
                            <Divider />
                            <div className={classes.box}>
                                <div className="fr-wrapper">
                                    <div className="fr-element fr-view" dangerouslySetInnerHTML={ {__html: answer} }>
                                    </div>
                                </div>
                                {/*<FroalaEditorView*/}
                                {/*    model={answer}*/}
                                {/*/>*/}
                            </div>
                        </div>
                    )}

                    <div className={classes.wtireButton}>
                        <Button variant="outlined" size="small" color="primary" onClick={handleListClick}>
                            목록
                        </Button>
                        <Button variant="contained" size="small" color="primary" onClick={handleModifyClick}>
                            수정
                        </Button>
                        {answer && (
                            <Button variant="contained" size="small" color="primary" onClick={handleReQuestionClick}>
                                재질문
                            </Button>
                        )}
                    </div>
                </div>
            </Grid>
    );
};

export default withRouter(ViewForm);
